import { Flex } from '@billy/design-system'
import { ReactElement } from 'react'

import { CompanyInformationModal } from '@features/invoicingSettings/elements/CompanyInformationModal'

import { ModalId } from '../../../../../../../../../../enums/modalId'
import { InvoiceIssuerField } from './elements/InvoiceIssuerField'

export const InvoiceIssuer = (): ReactElement => {
  return (
    <Flex flexGrow={1}>
      <InvoiceIssuerField />
      <CompanyInformationModal id={ModalId.CompanyInformationModal} />
    </Flex>
  )
}
